export default __webpack_public_path__ + "pgnv-assets/d9f67d2b3f98e48ecf88a0fd499aeac1.png";